module.exports = __webpack_public_path__ + "static/media/gradient_descent.c06f5f28.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/gradient_descent.png
// module id = 107
// module chunks = 0